import { Text, Title } from '@atom/typography/typography';

import { TitleWrapper, Wrapper } from './account-security.style';
import { ToggleMfa } from './toggle-mfa/toggle-mfa';

export const AccountSecurity = () => {
  return (
    <Wrapper>
      <TitleWrapper>
        <Title level={4} mb={0} weight={400}>
          Multi-Factor Authentication (MFA)
        </Title>
        <Text level='m' mb={0} paragraph>
          Allow team members ti authenticate to the WorkOS dashboard using your identity provider.
        </Text>
      </TitleWrapper>
      <ToggleMfa />
    </Wrapper>
  );
};
